import { createFileRoute } from '@tanstack/react-router';

/**
 * One partner's campaigns sheet, as a URL — `/ong-colaboradoras/<ngoId>` — so an open sheet can be
 * shared, bookmarked, and reached with the back button.
 *
 * Like the audience pages under `/new/contact`, it renders no UI of its own: the shell reads this
 * param with `useParams({ strict: false })` and owns the drawer, which is what lets Radix keep the
 * sheet mounted long enough to play its slide-out. A drawer mounted HERE would be unmounted the
 * instant the visitor closed it, and the exit animation would never run.
 *
 * No `beforeLoad` guard, unlike `contact.$audience`: whether an id names a partner is only knowable
 * from the roster, which is fetched. An id that matches nobody simply leaves the sheet closed — the
 * visitor lands on the directory, which is the truthful answer to "this partner is not listed".
 */
export const Route = createFileRoute('/new/partner-ngos/$ngoId')({
	component: () => null,
});
